import { render, staticRenderFns } from "./mourning.vue?vue&type=template&id=570265df&scoped=true&"
import script from "./mourning.vue?vue&type=script&lang=js&"
export * from "./mourning.vue?vue&type=script&lang=js&"
import style0 from "./mourning.vue?vue&type=style&index=0&id=570265df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570265df",
  null
  
)

export default component.exports